import axios from "axios";
import { authHeader, getValidToken } from "../utils/helper";
import { API_URL } from "../utils/helper";
import { config } from "../utils/config";

export const fetchAllUsers = (onSuccess = () => {}) => {

  const apiUrl = config.URL.FETCH_ALL_USER;

  return async () => {
    const token = await getValidToken();
    axios
      .get(apiUrl, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error in fetching users", e);
      });
  };
};

export const newPrivilege = (newPrev, onSuccess = () => {}) => {
  const apiUrl = config.URL.ADD_PERMISSION;
  return async () => {
    const token = await getValidToken();
    axios
      .patch(
        apiUrl,
        newPrev,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error you add new privilege", e);
      });
  };
};

export const deleteUser = (userId, onSuccess = () => {}) => {
  const apiUrl = `${config.URL.DELETE_USER}${userId}`;
  return async () => {
    const token = await getValidToken();
    axios
      .delete(
        apiUrl,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when you delete a user", e);
      });
  };
};
export const updateExistUser = (updateUser, onSuccess = () => {}) => {
  const apiUrl = config.URL.UPDATE_USER;
  return async () => {
    const token = await getValidToken();
    axios
      .patch(
        apiUrl,
        updateUser,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when update user", e);
      });
  };
};

export const createNewUser = (newUser, onSuccess = () => {}) => {
  const apiUrl = config.URL.CREATE_USER;
  return async () => {
    const token = await getValidToken();
    axios
      .post(
        apiUrl,
        newUser,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when you create a user", e);
      });
  };
};
